import { Box } from '@mui/material'
import EmptyStateBlock from './EmptyStateBlock'
import ThreadListRow from './ThreadListRow'
import styles from './AppsSection.module.scss'

export function AppsSectionList({ showAll, apps, onAppClick }) {
  if (apps.length > 0) {
    return (
      <Box className={styles.list}>
        {apps.map((app) => (
          <ThreadListRow key={app.id} title={app.name} onClick={() => onAppClick?.(app)} />
        ))}
      </Box>
    )
  }

  return (
    <EmptyStateBlock
      title="No Apps here"
      description="Connect your tools and pin apps here so agents can reach them in one place and help you move faster."
      variant="apps"
    />
  )
}
